<template>
  <div class="highSearch">
    <div class="search-form-index flex-between-nowrap" v-if="!highSearch.open">
      <span class="span-label">
        <em>主题：</em>
        <!-- <em class="c666">Topic</em> -->
      </span>
      <el-input
        ref="search"
        :class="['search-input']"
        clearable
        v-model="input"
        placeholder="可输入专家姓名、机构和关键词进行查询"
      >
        <el-button @click="simpleSearch" slot="append" icon="el-icon-search"></el-button>
      </el-input>
      <el-button class="search-btn bg05 fz16" type="primary" @click="addSearch">结果集中检索</el-button>
      <el-button class="search-btn bg05 fz16" type="primary" @click="closeOrOpenSearch">高级检索</el-button>
      <m-tips
        title="检索模式"
        content=" 检索模式共分为统一检索，结果集检索和高级检索。统一检索中您可通过输入专家姓名、机构和关键词进行查询，多个输入条件检索时，请使用空格或逗号进行分隔。
      <p style='color:red'>高级检索支持姓名、机构和关键词的独立输入，并可自定义检索条件的与或关系。</p>"
      ></m-tips>
    </div>
    <div class="search-form-index" v-else>
      <div class="high-search-box" v-for="(item, index) in highSearch.list" :key="index">
        <span class="span-label">
          <em>{{item.label}}：</em>
          <em class="c666">{{item.tips}}</em>
        </span>
        <el-input :class="['search-input']" clearable v-model="item.input" placeholder="输入搜索内容"></el-input>
        <el-select v-if="item.tag" v-model="item.selected" :class="['search-input search-select']">
          <el-option label="或" value="0"></el-option>
          <el-option label="与" value="1"></el-option>
        </el-select>
      </div>
      <div class="high-search-box">
        <el-button @click="highSearchClick" class="search-btn bg05 fz16" type="primary">高级检索</el-button>
        <span class="close-high cup" @click="closeOrOpenSearch">
          <i class="el-icon-arrow-up"></i> 收起
        </span>
      </div>
    </div>
    <!-- 检索范围：<span class="cff3">总库</span>    -->
    <div class="search-zone fz12">
      <em class="fsn" v-if="!highSearch.open">
        <span>检索词 ：{{ this.fieldData.params.k || ''}}</span>
        <span class="search-span" v-for="(item, index) in searchZone.list" :key="index">
          <i class="el-icon-arrow-right"></i>
          <!-- 主题： -->
          <em class="c53 fsn">{{ item}}</em>
        </span>
        <span class="cup close-span cffa fz16" @click="subSearch" v-if="searchZone.list.length">
          <i class="fwb el-icon-close verm"></i>
        </span>
      </em>
      <em class="fsn" v-if="highSearch.open">
        <span
          class="search-span"
          v-for="(item, index) in highSearch.list"
          v-if="item.input"
          :key="index"
        >
          {{item.label}}：
          <em class="c53 fsn">{{ item.input}}</em>
        </span>
      </em>
    </div>
  </div>
</template>

<script>
import mTips from "@/components/m-tips/m-tips";
export default {
  components: {
    mTips
  },
  data() {
    return {
      input: "",
      highSearch: {
        open: false,
        list: [
          {
            label: "主题",
            tips: "",
            input: "",
            selected: "0",
            tag: "kt",
            types: "k"
          },
          {
            label: "姓名",
            tips: "",
            input: "",
            selected: "0",
            tag: "nt",
            types: "n"
          },
          {
            label: "机构",
            tips: "",
            input: "",
            selected: "0",
            types: "o"
          }
          // {
          //     label:'学科',input:'',selected:'0',types:'s'
          // },
        ]
      },
      searchZone: {
        //集中检索数组
        list: []
      },
      fieldData: {
        total: 0,
        list: [],
        runtime: 0,
        params: {}
      },
      pageData: {
        size: 8,
        page: 1,
        from: 0
      } // 分页情况
    };
  },
  computed: {
    inputClone() {
      return this.input;
    },
    highSearchInput1() {
      return this.highSearch.list[0].input;
    },
    searchTxt() {
      console.log(this.$store.state.searchTxt);
      return this.$store.state.searchTxt;
    },
    highSearchClone() {
      return this.highSearch.open;
    }
  },
  watch: {
    inputClone(val) {
      if (val == undefined || val == "undefined") {
        this.highSearch.list[0].input = "";
      } else {
        this.highSearch.list[0].input = val;
      }
    },
    highSearchInput1(val) {
      //   this.input = val
    },
    highSearchClone(val) {
      this.$store.commit("setHighSearch", val);
    }
  },
  mounted() {
    this.input = this.fieldData.params.k =
      (localStorage.getItem("highVal")
        ? localStorage.getItem("highVal")
        : this.searchTxt) || "";
    if (this.input == undefined || this.input == "undefined") {
      this.input = this.fieldData.params.k = "";
    }
    if (localStorage.getItem("highSearch")) {
      let par = JSON.parse(localStorage.getItem("highSearch"));
      this.highSearch.open = true;
      this.highSearch.list.map((item, i) => {
        console.log(par[item.types] == undefined);
        this.highSearch.list[i].input = par[item.types];
        this.highSearch.list[i].selected = (par[item.tag] || 0) + "";
      });
    }
  },
  methods: {
    simpleSearch() {
      if (this.checkInput()) {
        this.searchZone.list = [];
        this.search();
      }
    },
    checkInput() {
      if (!this.input) {
        this.$message({
          message: "请输入检索词",
          type: "warning"
        });
        this.$refs.search.focus();
      }
      return this.input;
    },
    addSearch() {
      if (this.checkInput()) {
        this.searchZone.list.push(this.input);
        this.zoneSsearh("add");
        // k	用户输入内容（必填）
        // next 必传，传1
        // para	必传，已经检索内容，数组，如[“计算机”,”大数据”]
        //   this.search()
      }
    },
    subSearch() {
      // this.searchZone.list.pop()
      // this.input =  this.searchZone.list[this.searchZone.list.length-1] || this.fieldData.params.k;
      this.input = this.fieldData.params.k;
      this.simpleSearch();
    },
    zoneSsearh(add) {
      let para = JSON.parse(JSON.stringify(this.searchZone.list));
      para.unshift(this.fieldData.params.k);
      let queryk = JSON.parse(JSON.stringify(para));
      para.pop();
      queryk = queryk.filter(function(item, index, queryk) {
        //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
        return queryk.indexOf(item, 0) === index;
      });
      let params = {
        k: this.input,
        next: 1,
        para,
        queryk
      };
      this.pageData.page = 1;
      this.pageData.from = 0;
      console.log(params);
      this.search(params);
    },
    closeOrOpenSearch() {
      this.highSearch.list[0].input = this.input;
      this.highSearch.open = !this.highSearch.open;

      this.$nextTick(() => {
        if (this.highSearch.open) {
          // this.highSearchClick();
        } else {
          // this.search();
        }
      });
    },
    highSearchClick() {
      var params = {
        mix: 1,
        ...this.pageData
      };
      params.from = 0;
      this.highSearch.list.map(item => {
        if (item.input) {
          params[item.tag] = item.selected;
          params[item.types] = item.input;
        }
      });
      this.pageData.page = 1;
      this.pageData.from = 0;
      this.searchZone.list = [];
      this.input = params.k;
      this.search(params);
      console.log(this.highSearch.list);
    },
    search(par) {
      let params = par
        ? { ...par, ...this.pageData }
        : {
            k: this.input,
            ...this.pageData
          };
      if (!params.next) {
        if (params.k) {
          this.fieldData.params = JSON.parse(JSON.stringify(params));
        }
        if (!params.mix) {
          params.k = this.fieldData.params.k;
        }
      }
      delete params.page;
      sessionStorage.setItem("highSearch", JSON.stringify(params));
      this.$emit("highSearch", params);
    }
  }
};
</script>

<style  scoped lang="scss">
.cff3 {
  color: #ff3b30;
}
.c53 {
  color: #53a2e3;
}
.c666 {
  color: #666;
  font-size: 12px;
}
.cup {
  cursor: pointer;
}
.fwb {
  font-weight: bold;
}
.fsn {
  font-style: normal;
}
.cffa {
  color: #ffa914;
}
.fz16 {
  font-size: 16px;
}
.fz12 {
  font-size: 12px;
}
.flex-between-nowrap {
}
.highSearch {
  //  display: flex;
  // justify-content: flex-start;
}
.search-form-index {
  align-items: center;
  padding: 50px 70px 20px 70px;

  .span-label {
    font-weight: 400;
    display: inline-flex;
    flex-direction: column;

    em {
      font-style: normal;
    }
  }
  .search-input {
    width: 610px;
    >>> input {
      padding-right: 75px;
      text-indent: 10px;
      height: 60px;
    }
    >>> .el-input-group__append {
      width: 80px;
      text-align: center;
    }
    >>> .el-input__suffix {
      right: 20px;
    }
    >>> i {
      font-size: 22px;
      line-height: 60px;
    }
  }
  .high-search-box {
    margin-bottom: 30px;
    .close-high {
      color: #000;
    }
    .close-high:hover {
    }
  }
  .high-search-box {
    button {
      margin-left: calc(58px + 610px);
      width: 128px;
      padding: 0;
    }
  }
  .search-select {
    width: 128px;
  }
  .search-btn {
    height: 60px;
    margin-left: 10px;
    border-color: #050c42;
    padding: 0 34px;
  }
  .search-btn:hover {
    opacity: 0.8;
  }
}
.search-zone {
  padding-bottom: 40px;
  padding-left: 40px;
  .close-span:hover {
    color: #53a2e3;
  }
  span {
    i {
      margin-right: 10px;
    }
  }
  .search-span {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/highSearch.vue